import { c as i } from "./capitalize-iyaz5rT3.mjs";
import { j as o } from "./jsx-runtime-3tyXYecC.mjs";
import { B as d } from "./upper-content-DBsjRW7X.mjs";
import { f as t } from "./index-LyFokDcn.mjs";
import { m as n } from "./tss-DN0acMKN.mjs";
function v(e) {
  return `size${i(e)}`;
}
const u = n()(({ palette: e }) => ({
  defaultHeader: {
    alignItems: "center",
    backgroundColor: t.ifFeature("encore", e.common.white, void 0),
    borderTopLeftRadius: t.ifFeature("encore", "12px", void 0),
    borderTopRightRadius: t.ifFeature("encore", "12px", void 0),
    display: "flex",
    width: "100%",
    justifyContent: t.ifFeature("encore", "space-between", void 0)
  },
  defaultHeaderCloseButton: {
    padding: t.ifFeature("encore", "16px 20px 0 0", void 0)
  }
})), h = (e) => {
  const { children: s, hasCloseButton: a, ...l } = e, { classes: r } = u();
  return /* @__PURE__ */ o.jsxs("div", { className: r.defaultHeader, children: [
    /* @__PURE__ */ o.jsx("div", { children: s }),
    a ? /* @__PURE__ */ o.jsx("div", { className: r.defaultHeaderCloseButton, children: /* @__PURE__ */ o.jsx(d.CloseButton, {}) }) : null
  ] });
};
export {
  h as D,
  v as g
};
//# sourceMappingURL=default-header-CWb5N9vT.mjs.map
